import { Button } from "antd";
import axios from "axios";
import { create } from "zustand";

export let useVideos = create((set, get) => ({
    videos: [],
    videosLimit: [],
    ed: {},
    setEd: (data) => {
        set({ ed: data })
    },
    columns: [
        {
            title: 'ID',
            dataIndex: "id",
            key: "id",
            width: 50,
        },
        {
            title: 'Nomi',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Manzili',
            dataIndex: 'url',
            key: 'url',
            render: (text) => (
                <Button type="primary" href={text} target="_blank" rel="noopener noreferrer">
                    Ochish
                </Button>
            ),
        },
        {
            title: 'Kategoriya',
            dataIndex: 'category',
            key: 'category',
        },
        {
            title: 'Joylangan vaqti',
            dataIndex: 'created_at',
            key: 'created_at',
        },
    ],
    setVideo: async () => {
        axios.get('videos')
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                set({ videos: data });
            })
            .catch((err) => {
                console.error('Videolarni yuklab olishda xatolik:', err);
                set({ videos: [] });
            })
    },
    setVideosLimit: async () => {
        axios.get('videoslimit')
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                set({ videosLimit: data });
            })
            .catch((err) => {
                console.error('Cheklangan videolarni yuklab olishda xatolik:', err);
                set({ videosLimit: [] });
            })
    },
    delVideo: (id) => {
        axios.delete(`videos/${id.id}`)
            .then((res) => {
                get().setVideo();
            })
            .catch((err) => {
                console.error('Video o\'chirishda xatolik:', err);
            })
    },
    addVideo: (data) => {
        axios.post('videos', data)
            .then((res) => {
                get().setVideo();
            })
            .catch((err) => {
                console.error('Video qo\'shishda xatolik:', err);
            })
    },
    editVideo: (data) => {
        axios.put(`videos/${data.id}`, data)
            .then((res) => {
                get().setVideo();
            })
            .catch((err) => {
                console.error('Video taxrirlashda xatolik:', err);
            })
    }
}))